import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_EXTENSIONS_QUERY,
  CREATE_TRAVEL_EXTENSION_MUTATION,
  DELETE_TRAVEL_EXTENSION_MUTATION,
  FORCE_DELETE_TRAVEL_EXTENSION_MUTATION,
  SINGLE_TRAVEL_EXTENSION_QUERY,
  UPDATE_TRAVEL_EXTENSION_MUTATION,
} from './graphql'
import travelHighlightEntity from '@/entities/travelHighlight/entity'
import mediaFileEntity from '@/entities/mediaFile/entity'

const travelExtensionModel: EntityModel = {
  name: 'travelExtension',
  namePlural: 'travelExtensions',
  uniqueName: 'travelExtension',
  uniqueNamePlural: 'travelExtensions',
  path: 'travel/travel_extension',
  baseUrl: '/travel/travel_extensions',
  translationPrefix: 'entities:travelExtension.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_TRAVEL_EXTENSIONS_QUERY,
    getSingle: SINGLE_TRAVEL_EXTENSION_QUERY,
    create: CREATE_TRAVEL_EXTENSION_MUTATION,
    update: UPDATE_TRAVEL_EXTENSION_MUTATION,
    delete: DELETE_TRAVEL_EXTENSION_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_EXTENSION_MUTATION,
  },
  attributes: {
    duration: {
      name: 'duration',
      label: 'entities:travelExtension.attributes.duration.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:travelExtension.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:travelExtension.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    highlights: {
      name: 'highlights',
      label: 'entities:travelExtension.attributes.highlights.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return travelHighlightEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    image: {
      name: 'image',
      label: 'entities:travelExtension.attributes.image.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelExtensionModel
